import request from "@/utils/request";

export async function getIncompleteProductList(data) { //获取买手店列表
  return (await request({
    url: `/sc-basic-merchant-backend/incomplete/product/search`,
    method: "post",
    data
  })).data;
}

export async function incompleteProductPublish(data) { //获取买手店列表
  return (await request({
    url: `/sc-basic-merchant-backend/incomplete/product/publish`,
    method: "post",
    data
  })).data;
}

export async function validateIncompleteProduct(data) { //获取买手店列表
  return (await request({
    url: `/sc-basic-merchant-backend/incomplete/product/validate`,
    method: "post",
    data
  })).data;
}

export async function batchProcessIncompleteProduct(data) { //获取买手店列表
  return (await request({
    url: `/sc-basic-merchant-backend/incomplete/product/process/batch`,
    method: "post",
    data
  })).data;
}

export async function getIncompleteProductKeyword() {
  return (await request({
    url: `/sc-basic-merchant-backend/incomplete/product/category/keyword/view`,
  })).data;
}

export async function submitIncompleteProductKeyword(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/incomplete/product/category/keyword/submit`,
    method: "post",
    data
  })).data;
}
